import { z } from 'zod'

export const paramsSchema = z.object({
  cottageId: z.string(),
  event: z.enum(['click', 'conversion']),
})

export type paramsType = z.infer<typeof paramsSchema>
